"use client";

import { atom, useAtom } from "jotai";
import { useEffect } from "react";

const hasRenderedOnceAtom = atom(false);
export function usehasRenderedOnce() {
  const [hasRenderedOnce, setHasRenderedOnce] = useAtom(hasRenderedOnceAtom);
  useEffect(() => {
    setHasRenderedOnce(true);
  }, []);
  return hasRenderedOnce;
}
